import React, { useEffect, useState } from "react";
import { API_BASE_URL } from "src/config/apiBase";
import { decryptToken } from "../utils/getToken";

const CrmAttributionPanel = ({ days = 30 }) => {
  const [data, setData] = useState(null);
  const url = API_BASE_URL;
  const token = decryptToken("accessToken") || "";

  useEffect(() => {
    fetch(`${url}/leads/attribution-summary?days=${days}`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((r) => (r.ok ? r.json() : null))
      .then(setData)
      .catch(() => setData(null));
  }, [url, token, days]);

  if (!data) return <p className="crm-insights__muted">Loading attribution…</p>;
  if (!data.campaigns?.length) {
    return (
      <p className="crm-insights__muted">
        No UTM-tagged leads in the last {days} days. Pass utm_* params on lead forms or ads links.
      </p>
    );
  }

  return (
    <div className="crm-attribution">
      <p className="crm-insights__muted">
        {data.withUtm} of {data.totalLeads} leads have UTM attribution
      </p>
      <table className="crm-attribution__table">
        <thead>
          <tr>
            <th>Campaign</th>
            <th>Source</th>
            <th>Leads</th>
            <th>Converted</th>
            <th>Rate</th>
          </tr>
        </thead>
        <tbody>
          {data.campaigns.map((c) => (
            <tr key={c.campaign}>
              <td>{c.campaign}</td>
              <td>{c.source || "—"}</td>
              <td>{c.total}</td>
              <td>{c.converted}</td>
              <td>{c.conversionRate}%</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default CrmAttributionPanel;
